import { h } from "harmaja"
import * as L from "lonna"
import { Board, Connection, Drawing, drawingPath } from "../../../common/src/domain"
import { Dispatch } from "../store/board-store"
import { BoardCoordinateHelper } from "./board-coordinates"
import { BoardFocus } from "./board-focus"
import { DragBorder } from "./DragBorder"
import { itemDragToMove } from "./item-dragmove"
import { itemSelectionHandler } from "./item-selection"
import { ToolController } from "./tool-selection"
import { itemZIndex } from "./zIndices"

// A freehand stroke. SVG scales with the item box (preserveAspectRatio none), so resizing stretches the stroke.
export const DrawingView = ({
    id,
    drawing,
    board,
    isLocked,
    focus,
    toolController,
    coordinateHelper,
    latestConnection,
    dispatch,
}: {
    board: L.Property<Board>
    id: string
    drawing: L.Property<Drawing>
    isLocked: L.Property<boolean>
    focus: L.Atom<BoardFocus>
    toolController: ToolController
    coordinateHelper: BoardCoordinateHelper
    latestConnection: L.Property<Connection | null>
    dispatch: Dispatch
}) => {
    const { selected, onClick, onTouchStart } = itemSelectionHandler(
        id,
        "drawing",
        focus,
        toolController,
        board,
        coordinateHelper,
        latestConnection,
        dispatch,
    )
    return (
        <span
            className={L.view(selected, (s) => (s ? "drawing selected" : "drawing"))}
            data-itemid={id}
            draggable={true}
            onClick={onClick}
            onTouchStart={onTouchStart}
            ref={
                itemDragToMove(
                    id,
                    board,
                    focus,
                    toolController,
                    coordinateHelper,
                    latestConnection,
                    dispatch,
                    false,
                ) as any
            }
            style={L.view(drawing, (p) => ({
                top: 0,
                left: 0,
                transform: `translate(${p.x}em, ${p.y}em)`,
                height: p.height + "em",
                width: p.width + "em",
                zIndex: itemZIndex(p),
                position: "absolute",
            }))}
        >
            <svg
                width="100%"
                height="100%"
                viewBox={L.view(drawing, (d) => `0 0 ${d.width} ${d.height}`)}
                preserveAspectRatio="none"
                overflow="visible"
            >
                <path
                    d={L.view(drawing, (d) => drawingPath(d.points))}
                    fill="none"
                    stroke={L.view(drawing, "color")}
                    stroke-width={L.view(drawing, (d) => d.strokeWidth)}
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            {L.view(isLocked, (l) => l && <span className="lock">🔒</span>)}
            {L.view(selected, (s) =>
                s ? (
                    <DragBorder
                        {...{ id, board, toolController, coordinateHelper, latestConnection, focus, dispatch }}
                    />
                ) : null,
            )}
        </span>
    )
}
